import React from 'react'
import { MdOutlineMarkEmailRead } from "react-icons/md";

const RegistrationConfirmEmail = () => {
    return (
        <div className="container main-container-holder text-center" style={{ fontSize: '25px' }}>
            <div className="row mt-2">
                <MdOutlineMarkEmailRead size={150} color='var(--primary)' />
            </div>
            <div className="row mt-2">
                <b style={{ fontSize: '30px' }}>Twoje konto zostało utworzone.</b>
            </div>
            <div className="row mt-2 mb-2">
                <span>Na podany adres e-mail zostały wysłane dalsze instrukcje pozwalające na aktywację konta.</span>
            </div>
        </div>
    )
}

export default RegistrationConfirmEmail